import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  technicalSkills: [
    {
      id: '1',
      category: "SOC Tools",
      skills: ["Graylog SIEM", "OSSEC EDR", "Wazuh", "Suricata IDS", "PfSense Firewall", "TheHive"]
    },
    {
      id: '2',
      category: "Malware Analysis", 
      skills: ["FlareVM", "Remnux", "Autopsy", "Volatility", "YARA Rules"]
    },
    {
      id: '3',
      category: "Programming",
      skills: ["Python", "Bash", "SQL", "PowerShell"]
    },
    {
      id: '4',
      category: "IT Support",
      skills: ["Linux", "Windows", "Active Directory", "Networking Fundamentals"]
    },
    {
      id: '5',
      category: "Regulatory Awareness",
      skills: ["ISO/IEC 27001", "Cyber Essentials Plus Training"]
    },
    {
      id: '6',
      category: "Digital Forensics & Threat Detection",
      skills: ["Incident Response", "Log Analysis", "Network Monitoring", "IOC Extraction"]
    }
  ],
  softSkills: [
    {
      id: '1',
      skill: "Critical Thinking & Problem Solving",
      description: "Analytical approach to complex security challenges"
    },
    {
      id: '2',
      skill: "Effective Communication & Team Collaboration", 
      description: "Clear technical communication and cross-functional teamwork"
    },
    {
      id: '3',
      skill: "Customer Service Orientation",
      description: "User-focused approach to security solutions"
    },
    {
      id: '4',
      skill: "Time Management & Organization",
      description: "Efficient prioritization in high-pressure environments"
    },
    {
      id: '5',
      skill: "Research & Analytical Skills",
      description: "Continuous learning and threat intelligence analysis"
    },
    {
      id: '6',
      skill: "Cybersecurity Awareness & Education",
      description: "Training and mentoring others in security best practices"
    }
  ]
};

const skillsSlice = createSlice({
  name: 'skills',
  initialState,
  reducers: {
    addTechnicalSkill: (state, action) => {
      const newSkill = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.technicalSkills.push(newSkill);
    },
    updateTechnicalSkill: (state, action) => {
      const { id, ...updates } = action.payload;
      const skillIndex = state.technicalSkills.findIndex(skill => skill.id === id);
      if (skillIndex !== -1) {
        state.technicalSkills[skillIndex] = { ...state.technicalSkills[skillIndex], ...updates };
      }
    },
    deleteTechnicalSkill: (state, action) => {
      state.technicalSkills = state.technicalSkills.filter(skill => skill.id !== action.payload);
    },
    addSoftSkill: (state, action) => {
      const newSkill = {
        ...action.payload,
        id: Date.now().toString()
      };
      state.softSkills.push(newSkill);
    },
    updateSoftSkill: (state, action) => {
      const { id, ...updates } = action.payload;
      const skillIndex = state.softSkills.findIndex(skill => skill.id === id);
      if (skillIndex !== -1) {
        state.softSkills[skillIndex] = { ...state.softSkills[skillIndex], ...updates };
      }
    },
    deleteSoftSkill: (state, action) => {
      state.softSkills = state.softSkills.filter(skill => skill.id !== action.payload);
    },
    setTechnicalSkills: (state, action) => {
      state.technicalSkills = action.payload;
    },
    setSoftSkills: (state, action) => {
      state.softSkills = action.payload;
    }
  }
});

export const { 
  addTechnicalSkill, 
  updateTechnicalSkill, 
  deleteTechnicalSkill,
  addSoftSkill,
  updateSoftSkill,
  deleteSoftSkill,
  setTechnicalSkills,
  setSoftSkills 
} = skillsSlice.actions;
export default skillsSlice.reducer; 